import * as React from "react";
import type { SVGProps } from "react";
const SvgHeartAndHand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m43.013 52.875 5.27-9.36a15.35 15.35 0 0 0 1.95-7.49v-12.91a2.36 2.36 0 1 0-4.71 0v7.68h-1.75v-7.68a4.11 4.11 0 1 1 8.21 0v12.94a17 17 0 0 1-2.18 8.34l-5.23 9.33-1.56-.85ZM25.013 11.145a2.12 2.12 0 0 0-2.12 2.12v1h-1.76v-1a3.88 3.88 0 1 1 7.76 0v4h-1.76v-4a2.12 2.12 0 0 0-2.12-2.12ZM37.013 4.145a2.12 2.12 0 0 0-2.12 2.12v9h-1.76v-9a3.88 3.88 0 0 1 7.76 0v8.9h-1.76v-8.9a2.12 2.12 0 0 0-2.12-2.12Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M31.013 7.145a2.12 2.12 0 0 0-2.12 2.12v9h-1.76v-9a3.88 3.88 0 0 1 7.76 0v4.7h-1.76v-4.7a2.12 2.12 0 0 0-2.12-2.12ZM43.013 7.145a2.12 2.12 0 0 0-2.12 2.12v5h-1.76v-5a3.88 3.88 0 0 1 7.76 0v11h-1.76v-11a2.12 2.12 0 0 0-2.12-2.12Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M44.672 60.615a1 1 0 0 1-1 1h-18.56a1 1 0 0 1-1-1v-7.32a1 1 0 0 1 1-1h18.56a1 1 0 0 1 1 1v7.32Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M42.922 59.865v-5.82h-17.06v5.82h17.06Zm.75 1.75a1 1 0 0 0 1-1v-7.32a1 1 0 0 0-1-1h-18.56a1 1 0 0 0-1 1v7.32a1 1 0 0 0 1 1h18.56Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m19.853 32.515 6.07 20.47-1.68.53-6.07-20.5 1.68-.5ZM45.513 31.145c-5.08 0-9.62 4.13-9.62 9.09h-1.75c0-6 5.44-10.84 11.37-10.84v1.75Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M28.463 17.875c.6-.67 1.16-1.37 1.81-2a9.34 9.34 0 0 1 5.44-2.55 8 8 0 0 1 7.09 2.84 8.29 8.29 0 0 1 1.67 8.66 20.262 20.262 0 0 1-5.28 8 84.74 84.74 0 0 1-9.9 8.25.89.89 0 0 1-1.15.12 69.082 69.082 0 0 1-11.6-9.68 19.16 19.16 0 0 1-4-6.57 8.67 8.67 0 0 1 5.43-11.22 8.46 8.46 0 0 1 7.74 1.37 11.079 11.079 0 0 1 2.77 2.82l-.02-.04Zm15 3.4a6.81 6.81 0 0 0-3.61-5.52 6.5 6.5 0 0 0-6.69.05 9.2 9.2 0 0 0-3.83 3.91 1.33 1.33 0 0 1-.77.59c-.42.11-.65-.25-.82-.59a9.19 9.19 0 0 0-2.85-3.31 7.17 7.17 0 0 0-5-1.49 6.779 6.779 0 0 0-5.63 4.09c-1.09 2.19-.68 4.39.26 6.53a20.428 20.428 0 0 0 4.5 6.2 74.656 74.656 0 0 0 9.25 7.57.578.578 0 0 0 .85 0c2.35-1.93 4.75-3.8 7.06-5.78a24.883 24.883 0 0 0 5.78-6.73 10.832 10.832 0 0 0 1.46-5.52h.04Z"
    />
  </svg>
);
export default SvgHeartAndHand;
